const rpContractStatus = Object.freeze({
    NotAvailable: -1,
    Unset: 0,
    New: 1,
    Submitted: 2,
    Approved: 3,
    Denied: 4,
    ApprovedContractInformation: 5,
    DeniedContractInformation: 6,
    Signed: 7,
    ContractCanceled: 8,
    ContractAmended: 9,
  });
  
  export const rpContractStatusColor = Object.freeze({
    [rpContractStatus.NotAvailable]: 'orange',
    [rpContractStatus.New]: 'gray',
    [rpContractStatus.Submitted]: 'yellow',
    [rpContractStatus.Approved]: 'green',
    [rpContractStatus.Denied]: 'brown',
    [rpContractStatus.ApprovedContractInformation]: 'green',
    [rpContractStatus.DeniedContractInformation]: 'brown',
    [rpContractStatus.Signed]: 'orange',
    [rpContractStatus.ContractCanceled]: 'violet',
    [rpContractStatus.ContractAmended]: 'green',
  });
  
  export default rpContractStatus;